import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Indicators } from 'ui'
import { useAuthStatus } from './useAuthStatus'

export const SessionRedirect: React.FC = () => {
  const navigate = useNavigate()
  const { admin, authenticated, invalidSession } = useAuthStatus()
  useEffect(() => {
    if (invalidSession) {
      navigate('/session-expired', { replace: true })
      return
    }

    if (admin) {
      navigate('/admin', { replace: true })
      return
    }

    navigate(authenticated ? '/app/dashboard' : '/login', { replace: true })
  }, [admin, authenticated, invalidSession, navigate])

  return <Indicators.Spinner size="lg" />
}
